import type { ReactNode, FC } from 'react';
import EmptyResult from '../EmptyResult';

export interface Props {
  /**
   * Alternative to EmptyResult
   */
  customEmptyResult?: ReactNode;
  /**
   * A strip that we'll show after the empty state if we've got no content.
   */
  emptyContentStrip?: ReactNode;
  isEmpty?: boolean;
  children?: ReactNode;
}

export const ContentLoader: FC<Props> = ({
  isEmpty,
  customEmptyResult,
  emptyContentStrip,
  children,
}) => {
  if (isEmpty) {
    return (
      <>
        {customEmptyResult || <EmptyResult />}
        {emptyContentStrip}
      </>
    );
  }

  return <>{children}</>;
};
ContentLoader.displayName = 'ContentLoader';

export default ContentLoader;
